"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _snapsvg = require("snapsvg");

var _snapsvg2 = _interopRequireDefault(_snapsvg);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    data: function data() {
        return {
            state: "first",
            morphFirst: "M22.067,22.068c-29.48,29.479-29.415,77.342,0.145,106.9l74.311,74.312l74.506,74.507c29.561,29.561,77.424,29.625,106.902,0.145c29.48-29.479,29.416-77.342-0.145-106.9l-74.361-74.36l-74.457-74.457 C99.41-7.348,51.547-7.413,22.067,22.068z",
            morphSecond: "M0,0c0,97.813,0,77.188,0,149.375V300h150.314H300V149.375V0H150.314H0z"
        };
    },
    props: ['imageId', 'image'],
    methods: {
        mouseOver: function mouseOver(event) {
            this.state = "second";
            this.animate(event, this.morphSecond);
        },
        mouseLeave: function mouseLeave(event) {
            this.state = "first";
            this.animate(event, this.morphFirst);
        },
        animate: function animate(event, path) {
            (0, _snapsvg2.default)(event.target).stop().animate({
                'd': path
            }, 300, mina.linear);
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div class=\"contact-person-shape\" @mouseover=\"mouseOver\" @mouseout=\"mouseLeave\">\n    <svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 300 300\">\n        <defs>\n            <pattern id=\"contact-person-shape--style-{{imageId}}\" x=\"0\" y=\"0\" width=\"300\" height=\"300\" patternUnits=\"userSpaceOnUse\">\n                <image image-rendering=\"optimizeQuality\" preserveAspectRatio=\"none\" width=\"300\" height=\"300\" xlink:href=\"{{image}}\"></image>\n            </pattern>\n            <filter id=\"b\" width=\"1.1\" height=\"1.1\" x=\"-.05\" y=\"-.05\" color-interpolation-filters=\"sRGB\">\n                <feFlood result=\"flood\" flood-color=\"#000\" flood-opacity=\".39\"></feFlood>\n                <feComposite result=\"composite1\" operator=\"in\" in2=\"SourceGraphic\" in=\"flood\"></feComposite>\n                <feGaussianBlur result=\"blur\" stdDeviation=\"6.8\" in=\"composite1\"></feGaussianBlur>\n                <feOffset result=\"offset\" dy=\"6\" dx=\"-2.1\"></feOffset>\n                <feComposite result=\"composite2\" in2=\"offset\" in=\"SourceGraphic\"></feComposite>\n            </filter>\n        </defs>\n        <path fill=\"url(#contact-person-shape--style-{{imageId}})\" d=\"M22.07 22.07C-7.4 51.55-7.35 99.4 22.2 128.97l74.32 74.3 74.5 74.52c29.57 29.52 77.43 29.6 106.9.1 29.5-29.48 29.43-77.34-.13-106.9l-74.4-74.35-74.47-74.45C99.4-7.34 51.53-7.4 22.07 22.08\" transform=\"matrix(.9103 0 0 .90607 13.453 14.09)\" filter=\"url(#b)\"></path>\n    </svg>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  if (!module.hot.data) {
    hotAPI.createRecord("_v-97058256", module.exports)
  } else {
    hotAPI.update("_v-97058256", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}